export const keyCrypto = "P4ssw0rd3ndCr7pt";
export const language ="th";
export const AppTitle ="Recruitment";